import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import ReactPixel from 'react-facebook-pixel'
import notificationsUtils from '../../../utils/notifications/notificationsUtils'
import selectors from '../../../store/shared/selectors'
import AuthCard from '../../../components/ui/cards/AuthCard'
import NavBar from '../../../components/ui/navigation/NavBar'
import SignupForm from './components/SignupForm'
import * as insTokenDuck from '../Onboarding/insTokenDuck'

class UnauthenticatedSignupIndex extends Component {
  static propTypes = {
    history: PropTypes.any.isRequired,
    lessThanMedium: PropTypes.bool.isRequired,
    queryParams: PropTypes.any.isRequired,
    validateInsToken: PropTypes.func.isRequired,
    tokenOrganization: PropTypes.any,
  }

  constructor(props) {
    super(props)

    this.state = {
      accessLinkRequested: false,
    }
  }

  componentDidMount() {
    const { queryParams: { insToken, error } } = this.props
    if(insToken) this.props.validateInsToken({ insToken }).then(() => {}).catch(() => {})
    if(error) notificationsUtils.showErrorNotification(error)

    ReactPixel.pageView()
    ReactPixel.track('ViewContent')
  }

  render() {
    const { lessThanMedium, history } = this.props
    const { accessLinkRequested } = this.state

    return (
      <div>
        <NavBar />
        <div className="container">
          <div className="max-800">
            <AuthCard
              delay={0.3}
              title="Let's get started!"
            >
              <div style={{ marginBottom: 50, marginTop: 25 }}>
                <div className="max-400">
                  {accessLinkRequested ?
                    <div className={`col-12 ${lessThanMedium ? 'pt-0' : 'pt-3'}`}>
                      <i className="fas fa-check-circle" style={{ color: '#30bc9d', fontSize: 60, marginBottom: 10 }}/>
                      <h4 style={{ fontSize: 18 }}>Please check your email for access link!</h4>
                    </div>
                    :
                    <SignupForm setAccessLinkRequested={() => this.setState({ accessLinkRequested: true })}/>
                  }
                  <div style={{margin: 20}}/>
                  <div style={{margin: 6}}/>
                  <span>Already have an account?   
                  <Link to={{ pathname: '/login', search: history.location.search }}>
                    {`   LogIn Now`}
                  </Link>
                  </span>
                </div>
              </div>
            </AuthCard>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  tokenOrganization: insTokenDuck.getName(state),
  lessThanMedium: selectors.isLessThanMedium(state),
  queryParams: selectors.getQueryStringSimply(state)
})

const mapDispatchToProps = dispatch => bindActionCreators({
  validateInsToken: insTokenDuck.performValidateInsToken,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(UnauthenticatedSignupIndex)



// WEBPACK FOOTER //
// ./src/routes/unauthenticated/Signup/UnauthenticatedSignupIndex.js